import { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FormattedMessage } from 'react-intl';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

import { useTheme } from '@mui/material/styles';

import * as basicConstants from '../../constants/basic';
import {
  LinkExternalNormal
} from '../customComponent/link';


const HelpCenter = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const { userData } = props;
  const [target, setTarget] = useState(null);
  const isOpen = Boolean(target);

  const handleMenuOpen = (event) => {
    setTarget(event.currentTarget);
  };

  const handleMenuClose = () => {
    setTarget(null);
  };

  return (
    <>
      <Tooltip title={<FormattedMessage id="common.userManual" />} placement="bottom">
        <IconButton
          onClick={handleMenuOpen}
          sx={{
            color: isDesktop ? '#fff' : '#757575',
            mr: 1
          }}
        >
          <HelpOutlineOutlinedIcon />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={target}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        keepMounted
        open={isOpen}
        onClose={handleMenuClose}
        style={{
          zIndex: 2000,
        }}
      >
        <MenuItem>
          <LinkExternalNormal
            className="link--normal link--align--center"
            href="https://docs.google.com/presentation/d/1WDKUPOvj21BdJrM8q6jYENk1A0tHUYij2D5AINKWH6M/edit?usp=sharing"
            target="_blank"
          >
            Facebook <FormattedMessage id="common.userManual" />
          </LinkExternalNormal>
        </MenuItem>
        <MenuItem>
          <LinkExternalNormal
            className="link--normal link--align--center"
            href="https://docs.google.com/presentation/d/1I8a7E8ppNdYCfEmzIETl-4NbRSEi9WnB/edit?usp=share_link&ouid=113476795202908064137&rtpof=true&sd=true"
            target="_blank"
          >
            Google <FormattedMessage id="common.userManual" />
          </LinkExternalNormal>
        </MenuItem>
        <MenuItem>
          <LinkExternalNormal
            className="link--normal link--align--center"
            href="https://docs.google.com/presentation/d/1CJD07AbyZgDY00w-mzK8UPNj9rU5uRhG/edit#slide=id.p1"
            target="_blank"
          >
            LINE <FormattedMessage id="common.userManual" />
          </LinkExternalNormal>
        </MenuItem>
        <MenuItem>
          <LinkExternalNormal
            className="link--normal link--align--center"
            href="https://docs.google.com/presentation/d/1H7HgxTpQ6q-7uF9QIzB68SrKrapG074j/edit?usp=sharing&ouid=113476795202908064137&rtpof=true&sd=true"
            target="_blank"
          >
            Taboola <FormattedMessage id="common.userManual" />
          </LinkExternalNormal>
        </MenuItem>
        {/* {
          // userData.role !== basicConstants.ROLE_VIEWER &&
          <MenuItem>
            <LinkExternalNormal
              className="link--normal link--align--center"
              href="https://forms.gle/EmNTEpMoHQEqRt3B6"
              target="_blank"
            >
              使用回饋
            </LinkExternalNormal>
          </MenuItem>
        } */}
      </Menu>
    </>
  )
}

export default HelpCenter;